// Ticking hooks (architecture sprint-04 §5.3, §2.2). Only components that display live time mount
// these; the pure models receive the values as arguments.
import { todayIn, type IanaZone, type LocalDate } from '@shared/calendar';
import { useEffect, useState } from 'react';

const TODAY_RECHECK_MS = 60_000;

/** performance.now(), re-rendering every `intervalMs`. */
export function useNowTick(intervalMs: number): number {
  const [now, setNow] = useState(() => performance.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(performance.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}

/** The user's today (browser clock + their zone), re-evaluated every minute so pages roll over at midnight. */
export function useToday(tz: IanaZone): LocalDate {
  const [today, setToday] = useState(() => todayIn(tz));
  useEffect(() => {
    setToday(todayIn(tz));
    const id = window.setInterval(() => setToday(todayIn(tz)), TODAY_RECHECK_MS);
    return () => window.clearInterval(id);
  }, [tz]);
  return today;
}
